export const router = [
  {
    path: 'backed',
    component: (resolve) => require(['./layout/Index.vue'], resolve),
    children: [
      {
        path: 'customerRegister',
        component: (resolve) => require(['./customer-register/Index.vue'], resolve)
      }
    ]
  }
]
